<template>
  <QS-scroller-box>
    <EchoLastData
       :dataList="orderPayPreview"
       :model="topPreviewModel"
     />
    <QS-h4-title title="发车前收款信息" />
    <div>
      <div>
        <el-button
          type="primary"
          :disabled="batchOfflineCollectAble"
          @click="batchOfflineCollect"
        >
          批量线下收款
        </el-button>
        <i class="cut-off"></i>
        <el-button
          @click="
            () => {
              showOrderReceiptDialog = true
              $refs.orderReceiptList && $refs.orderReceiptList.fetchReceiptList && $refs.orderReceiptList.fetchReceiptList()
            }
          "
          >订单收款记录</el-button
        >
        <el-button
          type="primary"
          @click="reloadState"
        >
          刷新收款状态
        </el-button>
      </div>
      <!-- 收款信息列表 -->
      <QS-common-table
        :header-cell-class-name="cellClass"
        v-loading="receiptLoading"
        :columns="c_receiptColumns"
        :pagination="receiptPagination"
        :data="receiptData"
        @change="receiptTableChange"
        @selection-change="
          (selectedItems) => {
            this.receiptSelectedItems = selectedItems
          }
        "
      ></QS-common-table>
    </div>
    <!-- 订单收款记录弹窗 -->
    <dialogWrap
      v-model="showOrderReceiptDialog"
      :width="'824px'"
      title="订单收款记录"
    >
      <orderReceiptList
        ref="orderReceiptList"
        @revokeSuccess="revokeSuccess"
        @closeDialog="() => showOrderReceiptDialog = false"
      ></orderReceiptList>
    </dialogWrap>
    <template slot="bottomAction">
      <el-button @click="cancel" size="mini">取消</el-button>
      <el-button @click="confirm" size="mini" :loading="loading" type="primary">提前发车，下一步</el-button>
    </template>
  </QS-scroller-box>
</template>

<script>
// api
import { getReceivableList } from '@/api/domain/finance'
// 组件
import orderReceiptList from './orderReceiptList'
import { skipPayment, leaseContractOrderDetail } from '@/api/domain/orders'
// 配置
import config from '../../config/orderPayment'
import { orderPayPreview } from '../../config/echoLastData'
// 其他
import { mapState } from 'vuex'
import selectOption from '@/store/dict/selectOptionDict'
import EchoLastData from '../../../components/EchoLastData.vue'
import { batchOfflineCollectCheck } from '@/pages/utils/overdue'

export default {
  components: {
    orderReceiptList,
    EchoLastData,
  },
  props: {
    topPreviewModel: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    const {
      c_receiptColumns,
    } = config.call(this)
    return {
      orderPayPreview,
      c_receiptColumns,
      // 是否展示收款记录弹窗
      showOrderReceiptDialog: false,
      receiptLoading: false,
      loading: false, // 提前发车按钮loading
      // 收款数据
      receiptData: [],
      // 收款--分页
      receiptPagination: {
        pageSize: 10,
        pageNum: 1,
        total: 0,
      },
      // 收款被选中项
      receiptSelectedItems: [],
    }
  },
  computed: {
    ...mapState({
      freeTypeList: (state) => state.global.freeTypeList, // 收款项
    }),
    batchOfflineCollectAble() {
      return !this.receiptSelectedItems.length
    },
  },
  created() {
    // eslint-disable-next-line vue/no-mutating-props
    this.topPreviewModel.orderId = this.$route.query.orderId || ''
  },
  mounted() {
    this.init()
  },
  methods: {
    // 刷新收款状态
    reloadState() {
      leaseContractOrderDetail({
        orderId: this.topPreviewModel.orderId,
      }).then((res) => {
        const { code, data } = res
        const { state } = data
        if (code === 1 && state === 1500) {
          this.$message({
            message: '发车前收款项已全部收款完成，将自动自动下一步',
            type: 'success',
            duration: 2000,
          })
          const timer = setTimeout(() => {
            this.$emit('confirm')
            clearTimeout(timer)
          }, 2000)
        }
      })
      this.getReceivableList()
    },
    // 执行线下收款
    // eslint-disable-next-line vue/no-unused-properties
    offlineReceipt({ id }) {
      const query = {
        type: 'order',
        paymentIds: id,
        // 1: '应收列表线下收款',2: '应收列表批量线下收款',3: '个人订单详情线下收款',4: '个人订单详情批量线下收款',
        // 5: '企业租赁订单详情线下收款',6: '企业租赁订单详情批量线下收款',7: '催收预提醒线下收款',8: '催收逾期线下收款',
        // 9: '采购订单详情线下收款',10: '采购订单详情批量线下收款'
        approvalOrigin: 5,
      }
      // 进行页面跳转
      this.$router.push({
        path: '/workbench/batchCollectionRecordAdd',
        query,
      })
    },
    revokeSuccess() {
      this.getReceivableList()
    },
    // 应收分页事件
    receiptTableChange(payload) {
      this.receiptLoading = true
      this.receiptPagination.pageNum = payload.pagination.pageNum
      this.receiptPagination.pageSize = payload.pagination.pageSize
      this.getReceivableList()
    },
    // 应收列表
    async getReceivableList() {
      const { code, data } = await getReceivableList({
        sourceOrderId: this.topPreviewModel.orderId,
        pageNum: this.receiptPagination.pageNum,
        pageSize: this.receiptPagination.pageSize,
        advancePayment: 1,
      })
      this.receiptLoading = false
      if (code === 1) {
        this.receiptData = data.items
          ? data.items.map((item) => {
            return {
              ...item,
              changeState: selectOption.payeechange[item.changeState],
              receivableState:
              selectOption.completionStatusDict[item.receivableState],
              content: this.formatEnumeration(this.freeTypeList)[item.content],
            }
          })
          : []
        this.receiptPagination.total = data.totalNum
        return this.receiptData
      }
    },
    cellClass(row) {
      // this.receiptData = []
      // 获取可选数据的条数的长度（剩余应收金额为0，item.remainAmount === 0 ）
      const len = this.receiptData.filter((item) => !(Number(item.remainAmount) === 0 || item.receivableState === '已完成' || item.receivableState === '已关闭')).length
      if (row.columnIndex === 0 && !len) {
        return 'disableSelection'
      }
    },
    // 批量线下收款能力
    batchOfflineCollect() {
      // 筛选出所有订单ID
      const idList = this.receiptSelectedItems.map((obj) => obj.id).join(',')
      batchOfflineCollectCheck(idList).then((res) => {
        if (res?.code === 1) {
          // 进行页面跳转
          this.$router.push({
            path: '/workbench/batchCollectionRecordAdd',
            query: {
              paymentIds: idList,
              type: 'order',
              approvalOrigin: 6,
            },
          })
        }
      })
    },
    // 获取详情
    getLeaseContractOrderDetail() {
      leaseContractOrderDetail({
        orderId: this.$route.query.orderId,
      }).then((res) => {
        const { data } = res
        if (data) {
          const {
            state,
            carId,
            deptName,
            customerName,
            planName,
            modelName,
            plateNo,
            rentCategoryName,
            startDate,
            endDate,
            entRentOrderId,
            brandName,
            seriesName,
          } = data

          /* eslint-disable vue/no-mutating-props */
          this.topPreviewModel.state = state
          this.topPreviewModel.deptName = deptName
          this.topPreviewModel.customerName = customerName
          this.topPreviewModel.planName = planName || '自定义'
          this.topPreviewModel.brandName = brandName
          this.topPreviewModel.seriesName = seriesName
          this.topPreviewModel.modelName = modelName
          this.topPreviewModel.plateNo = plateNo
          this.topPreviewModel.carId = carId
          if (startDate && endDate) {
            this.topPreviewModel.startStopDate = `${startDate}至${endDate}`
          }
          if ([1500, 2500].includes(Number(state))) { // state:1500 发车验车;state:2500完成-签约提车完成（履约中)
            this.toNext(state)
          }
          this.topPreviewModel.entRentOrderId = entRentOrderId
          this.topPreviewModel.categoryName = rentCategoryName
          /* eslint-enable vue/no-mutating-props */
        }
      })
    },
    // 取消
    cancel() {
      this.$confirm('是否确认退出创建企业签约提车流程?退出后可在"待租车辆列表-企业子租赁订单-订单待支付"状态下找到订单并继续', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.$refreshBack() // 关闭当前tab
        this.$router.push({
          path: '/car_to_lease/forRentSignContract',
          query: {
            activeName: 'child',
          },
        })
      }).catch(() => null)
    },

    // 查询签约提车流转状态
    async getOrderState() {
      this.loading = true
      const { data } = await leaseContractOrderDetail({
        orderId: this.topPreviewModel.orderId,
      })
      this.loading = false
      return data
    },

    // 下一步
    toNext(state) {
      if (Number(state) === 1500) { // state:1500 发车验车
        this.$emit('confirm')
      } else if (Number(state) === 2500) { // state:2500 完成-签约提车完成（履约中）
        this.$emit('confirm', 5)
      }
    },

    // 确认
    async confirm() {
      const data = await this.getOrderState()
      if (!data) {
        this.reloadState()
        return
      }
      if ([1500, 2500].includes(Number(data.state))) { // state:1500 发车验车;state:2500完成-签约提车完成（履约中)
        this.toNext(data.state)
      } else {
        this.loading = true
        skipPayment({
          orderId: this.topPreviewModel.orderId,
        }).then((res) => {
          const { code } = res
          if (code === 1) {
            this.$emit('confirm')
          }
          this.loading = false
        }).catch(() => {
          this.loading = false
        })
      }
    },

    init() {
      // 获取详情
      this.getLeaseContractOrderDetail()
      // 获取应收列表
      this.getReceivableList()
      // 获取收款项
      this.$store.dispatch('getPaymentMethods', { type: 'financeFeeType' }) // 获取收款项
    },
  },
}
</script>

<style lang="scss" scoped>
.cut-off {
  border-right: 1px solid #dcdee0;
  height: 24px;
  display: inline-block;
  vertical-align: middle;
  margin: 0px 5px;
}
</style>
